import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { CITIES } from '../api/citiesPage';
import { CITIES_PAGE_INTERFACE } from '../api/citiesPage';
import { CARDMEDIAINTERFACE } from '../api/commonInterfaces';
import Image from 'next/image';
import FEATUREDEXPERIENCES, {
  FEATURED_EXPERIENCES_INTERFACE,
  HOMEPAFE
} from '../api/featuredexperiences';
import client from '../apollo-client';
import Card from '../components/Card';
import FeaturedExperiences from '../components/FeaturedExperiences/FeaturedExperiences';
import Trustbar from '../components/Trust/Trustbar';
import PageHero from '../layouts/PageHero';
import { DAY_TOUR_INTERFACE } from '../api/dayToursPage';

import Head from 'next/head';
import CitiesModal from '../components/CitiesModal.tsx';
import { useRouter } from 'next/router';
import PrivateText from '../components/PrivateToursContent/Text';
import FaqPrivate from '../components/PrivateToursContent/Faq';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import SwiperCore, { Autoplay, Navigation, EffectFade } from 'swiper';
import {
  LeftSwipperArrows,
  RightSwipperArrows
} from '../shared-components/SwipperArrows/SwipperArrows';
import { replaceTripshepherdWithSeeSight } from '../utils/trip-sheppered-text';
SwiperCore.use([Autoplay, Navigation, EffectFade]);
const metaData = {
  title: 'Customized Private Tours for Individuals and Groups',
  meta: ' Private tours are the perfect way to see the world your way. With a private guide, you can customize your itinerary to fit your interests and time constraints. ',
  canonical: 'https://seesight-tours.com/private-tours'
};
const Tours = ({
  featuredExp,
  citydropdown,
  cities,
  privateTourPage
}: IProps) => {
  const router = useRouter();
  const [isLastSlide, setIsLastSlide] = useState(false);
  const [isFirstSlide, setIsFirstSlide] = useState(false);
  const handleSlideChange = (swiper: any) => {
    setIsLastSlide(swiper.isEnd);
    setIsFirstSlide(swiper.isBeginning);
  };
  const handleSwiperInit = (swiper: any) => {
    setIsFirstSlide(swiper.isBeginning);
    setIsLastSlide(swiper.isEnd);
  };
  return (
    <>
      <Head>
        <meta name="og:title" content={metaData.title}></meta>
        <meta name="og:description" content={metaData.meta} />
        <title>{metaData.title}</title>
        <meta name="description" content={metaData.meta} />
        <link
          href={
            metaData.canonical
              ? 'https://www.seesight-tours.com/private-tours'
              : metaData.canonical
          }
          rel="canonical"
          key="canonical"
        />
        <meta name="og:image" content="/vertical-seesight-logo.png" />
      </Head>

      <section id="hero" className="relative">
        <PageHero
          title={'The Best Private Tours Experience '}
          snippet={
            ' Best Private Tours. Operating Across Canada and the United States'
          }
          media="https://res.cloudinary.com/see-sight-tours/video/upload/v1658237954/landing-page-hero_mu19mc.mp4"
          video={true}
        />
        <CitiesModal />
      </section>
      <Trustbar />
      <FeaturedExperiences
        featuredExp={featuredExp}
        citydropdown={citydropdown}
        privateTourPage={privateTourPage}
      />

      <PrivateText />
      <div className="w-[90%] lg:w-[85%] 3xl:w-[70%]  max-w-[1750px] mx-auto  ml-5 sm:ml-20 md:ml-20 lg:ml-32 2xl:ml-[15%]  pt-3 pb-10 ">
        <h2 className="font-semibold text-2xl md:text-2xl lg:text-4xl pt-12    ">
          Our Cities
        </h2>

        <Swiper
          className="swiper_123 relative "
          spaceBetween={20}
          slidesPerView={1}
          effect="slide"
          grabCursor
          onSlideChange={(swiper: any) => handleSlideChange(swiper)}
          onInit={(swiper: any) => handleSwiperInit(swiper)}
          navigation={{ prevEl: '.prevSlide', nextEl: '.nextSlide' }}
          a11y={{ enabled: true }}
          observer
          observeParents
          observeSlideChildren
          breakpoints={{
            400: {
              slidesPerView: 1.3
            },
            768: {
              slidesPerView: 2
            },
            800: {
              slidesPerView: 2.8
            },
            1024: {
              slidesPerView: 3
            },
            1200: {
              slidesPerView: 4
            }
          }}
        >
          {cities &&
            cities.map((city, index) => {
              {
                if (city?.city) {
                  return (
                    <SwiperSlide key={city.city.id}>
                      <Card
                        index={index}
                        slug={city.city.slug}
                        image={city.city.cardMedia[0]?.url}
                        cardSnippet={city.city.cardSnippet}
                        city={city.city.name}
                      />
                    </SwiperSlide>
                  );
                }
              }
            })}
        </Swiper>
        <div id="slider-btn" className="flex justify-center mt-8">
          <div className="flex gap-2">
            <div className="prevSlide">
              <LeftSwipperArrows isFirstSlide={isFirstSlide} />
            </div>
            <div className="nextSlide">
              <RightSwipperArrows isLastSlide={isLastSlide} />{' '}
            </div>
          </div>
        </div>
      </div>
      <FaqPrivate />
    </>
  );
};

interface IProps {
  query: any;
}

export async function getStaticProps() {
  const { data } = await client.query<FEATURED_EXPERIENCES_INTERFACE>({
    query: FEATUREDEXPERIENCES,
    variables: {
      dayTours: true,
      multiday: true,
      airportTransfers: true
    }
  });
  const { data: citiesData } = await client.query<CITIES_PAGE_INTERFACE>(
    CITIES
  );

  return {
    props: {
      featuredExp:
        data?.homePage &&
        JSON.parse(
          replaceTripshepherdWithSeeSight(JSON.stringify(data.homePage))
        ),
      citydropdown: data.citiesDropdown,
      cities: citiesData.citiesPage.featured,

      privateTourPage: true
    }
  };
}
interface IProps {
  featuredExp: HOMEPAFE;
  citydropdown: [
    {
      id: string;
      name: string;
      slug: string;
    }
  ];
  cities: [
    {
      city: {
        id: string;
        name: string;
        slug: string;
        cardSnippet: string;
        cardMedia: [CARDMEDIAINTERFACE];
      };
    }
  ];
  dayTour: DAY_TOUR_INTERFACE;
  privateTourPage: boolean;
}
export default Tours;
